import { toast } from "sonner";
import { ApiProblem, GENERIC_ERROR } from "@/api/errors";

/** Shows the server's human message (never raw codes or internals). */
export function notifyError(problem: unknown) {
  toast.error(problem instanceof ApiProblem ? problem.message : GENERIC_ERROR);
}
